<template>
    <div>
        <b-modal
            id="post-community-modal"
            header-class="no-border"
            centered
            hide-footer
            ref="post-community-modal"
        >
            <template v-slot:modal-header="{ close }">
                <p class="text-primary text-bold">{{trans('community.add_your_post')}}</p>
                <b-icon icon="x" v-on:click="close()" scale="2" class="close-button" variant="primary"></b-icon>
            </template>
            <div class="row">
                <div class="col-12">
                    <post-form
                        :post-data="userPost"
                        :title="postTitle"
                        :loading="postLoading"
                        @onEditPost="(postData)=>$emit('onEditPost',postData)"
                        @onCreatePost="(postData)=>$emit('onCreatePost',postData)"
                    />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import PostForm from "../molecules/PostForm";
    export default {
        name: "PostCommunityModal",
        components: {PostForm},
        props:{
            moduleId: Number,
            userPost: Object,
            postTitle: String,
            postLoading: Boolean
        }
    }
</script>
